import AmpEvents from '@amplify/amp-events';
import queryString from 'query-string';
import { types } from './trcReporting';
import getEnvironmentName from '../common/lrs/lrsHelpers';
import packageJson from '../../package.json';

const AR_APP_NAME = 'amplify-reading';
const AR_URL = 'reading.amplify.com';

const MCLASS_APP_NAME = 'Flex';
const MCLASS_URL = 'mclass.amplify.com';

// Copied version from package.json.
const APP_VERSION = packageJson.version;

const ENV = getEnvironmentName();

const LANGUAGE = 'en-US';

export const initTROEvents = source => {
    const eventFactory = new AmpEvents({
        [AmpEvents.OPTIONS.APP_NAME]: source === 'AR' ? AR_APP_NAME : MCLASS_APP_NAME,
        [AmpEvents.OPTIONS.APP_VERSION]: APP_VERSION,
        [AmpEvents.OPTIONS.LANGUAGE]: LANGUAGE,
        [AmpEvents.OPTIONS.ENVIRONMENT]: ENV,
    });
    return eventFactory;
};
export const createTROEventsMiddleware = () => {
    const { source } = queryString.parse(window.location.search);
    let xapi;
    try {
        xapi = initTROEvents(source);
    } catch {
        // If unable to init TROEvents lib - do not break middleware chain.
        return () => next => action => next(action);
    }

    return () => next => async action => {
        if (action.type === types.TRACK_TRO_EVENT) {
            let trackerObject;
            try {
                trackerObject = xapi.eventFactory
                    .create()
                    .addActorAccount('name', action.userId)
                    .addActorAccount('homePage', source === 'AR' ? AR_URL : MCLASS_URL)
                    .addVerbId(action.verbId)
                    .addVerb('display', { [LANGUAGE]: action.verbId })
                    .addObject('id', action.objectId);
                Object.entries(action.contextConfig).forEach(([key, value]) =>
                    trackerObject.addContextExtension(key, value),
                );
                if (action.resultConfig) {
                    Object.entries(action.resultConfig).forEach(([key, value]) =>
                        trackerObject.addResultExtension(key, value),
                    );
                }
                if (ENV === 'devci') {
                    // Show event data in console
                    // eslint-disable-next-line no-console
                    console.log('amp-events statement', trackerObject.statement);
                }
                await trackerObject.emit();
            } catch {
                // If unable to create or emit TRO (XAPI) event - do not break middleware chain.
                return next(action);
            }
        }
        return next(action);
    };
};

export const troEventsMiddleware = createTROEventsMiddleware();

export default troEventsMiddleware;
